export default function EmptyNote(){
    return <p className="notes-list__empty-message">Tidak ada catatan</p>
}